import { createContext } from 'react';
import { Stripe } from '@stripe/stripe-js';

export interface AppContextProps {
  stripePromise: Promise<Stripe | null>;
}

export const AppContext = createContext<AppContextProps | undefined>(undefined);
